import { Avatar, Button, Stack, Typography } from '@mui/material';
import {
  IParentCategory,
  ISubCategory,
} from 'API/UniversalRequest/universalRequest';
import { TAB_VALUE_TYPE } from '..';
import { SubCategoriesListItem } from './SubCategoriesListItem';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { BackButtonArrow } from 'Images';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

interface ISubCategoriesList {
  categoriesList: {
    subjects: IParentCategory[];
    departments: IParentCategory[];
    subSubjects: ISubCategory[];
  };
  tabValue: TAB_VALUE_TYPE;
  selectedCategoryId: number | null;
  handleSubCategoryClick: (subCategoryId: number) => void;
  goBack: () => void;
}

export const SubCategoriesList = ({
  categoriesList,
  tabValue,
  selectedCategoryId,
  handleSubCategoryClick,
  goBack,
}: ISubCategoriesList) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  const filteredSubCategories = categoriesList.subSubjects
    .filter((subSubject) =>
      categoriesList[
        tabValue === TAB_VALUE_TYPE.SUBJECTS ? 'subjects' : 'departments'
      ]
        .find((category) => category.id === selectedCategoryId)
        ?.subSubjectIds.includes(subSubject.id)
    )
    .sort(
      (a, b) => a.title.localeCompare(b.title, 'he', { numeric: true }) as any
    );

  // place 'נושא אחר' subcategory at the end of the array
  const otherSubCategory = filteredSubCategories.find(
    (subCategory) => subCategory.title.trim() === dictionary.otherSubject
  );
  if (otherSubCategory) {
    filteredSubCategories.splice(
      filteredSubCategories.indexOf(otherSubCategory),
      1
    );
    filteredSubCategories.push(otherSubCategory);
  }

  const params = useParams();

  useEffect(() => {
    if (!!params.subCategoryId) {
      handleSubCategoryClick(parseInt(params.subCategoryId));
    }
  }, [handleSubCategoryClick, params.subCategoryId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Stack
      maxWidth='680px'
      m='64px auto 0'
      p={isDesktop ? '32px 90px 48px' : '0 24px'}
      bgcolor={isDesktop ? '#E7EDFF' : undefined}
      border={isDesktop ? '1px solid #B7CCFF' : undefined}
      borderRadius='20px'
      gap='12px'
    >
      <Typography variant={'body1'} mb='4px' tabIndex={0}>
        {dictionary.inWhatMatter}
      </Typography>
      {filteredSubCategories.length > 0 ? (
        filteredSubCategories.map((subSubject) => (
          <SubCategoriesListItem
            key={subSubject.id}
            subCategory={subSubject}
            handleSubCategoryClick={handleSubCategoryClick}
          />
        ))
      ) : (
        <Typography>{dictionary.noAvailableDisabilityConfirmations}</Typography>
      )}
      <Button
        variant='outlined'
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: '12px 0',
          width: isDesktop ? '234px' : '208px',
          m: '52px auto 0',
          borderColor: 'primary.main',
          bgcolor: '#fff',
          '&:hover': {
            bgcolor: '#fff',
          },
        }}
        onClick={goBack}
      >
        <Avatar
          src={BackButtonArrow}
          alt={''}
          sx={{
            width: isDesktop ? '20px' : '16px',
            height: isDesktop ? '20px' : '16px',
          }}
        />
        <Typography variant={'body4'} color={'primary.main'}>
          {Dictionary[DICTIONARY.General].back}
        </Typography>
      </Button>
    </Stack>
  );
};
